import { TFormFields } from 'components/Base/Form/Form.types';
import { TFormFieldTypes } from 'components/Base/Form/FormItem/type';
import { validationRules } from 'components/Base/Form/validationRules';

export const loginEmailFields: TFormFields = {
  email: {
    fieldType: TFormFieldTypes.INPUT,
    formItemLabel: 'Email address',
    rules: [
      { required: true, message: 'Please enter your email address!' },
      { type: 'email', message: 'Incorrect Email Address!' },
    ],
    placeholder: 'Enter email address',
  },
  password: {
    fieldType: TFormFieldTypes.PASSWORD,
    formItemLabel: 'Password',
    rules: [...validationRules.password, validationRules.required('password')],
    placeholder: 'Enter password',
  },
};

export const loginPhoneNumberFields: TFormFields = {
  phoneNumber: {
    fieldType: TFormFieldTypes.PHONE_INPUT,
    formItemLabel: 'Phone number',
    rules: [
      { required: true, message: 'Please enter your phone number!' },
      validationRules.phoneNumber(),
    ],
    placeholder: 'Enter phone number',
  },
  password: {
    fieldType: TFormFieldTypes.PASSWORD,
    formItemLabel: 'Password',
    rules: [...validationRules.password, validationRules.required('password')],
    placeholder: 'Enter password',
  },
};
